import React from "react";
import WallpaperOutlinedIcon from "@mui/icons-material/WallpaperOutlined";
import { uploadTrustCenterHeroImage } from "../../../../apis/trust-center-apis/trustCenterApis";
import {
  HERO_ACCEPT_ATTRIBUTE,
  HERO_HINT,
  validateHeroImage,
} from "../../data/uploadRules";
import BrandImageField from "./BrandImageField";

// Banner image behind the public page's hero (banner style "Image").
const HeroImageField = ({ heroImagePath, onChange, onUploading, error }) => (
  <BrandImageField
    name="Hero image"
    path={heroImagePath}
    pathKey="heroImagePath"
    upload={uploadTrustCenterHeroImage}
    validate={validateHeroImage}
    hint={`${HERO_HINT}.`}
    icon={WallpaperOutlinedIcon}
    accept={HERO_ACCEPT_ATTRIBUTE}
    onChange={onChange}
    onUploading={onUploading}
    error={error}
  />
);

export default HeroImageField;
